var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2RevampedLobbyCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8547 2.16699H12.636C10.7248 2.16698 9.21092 2.16696 8.02614 2.32689C6.80682 2.49148 5.81991 2.83827 5.04162 3.6197C4.26333 4.40112 3.91792 5.39199 3.75399 6.61621C3.59469 7.80574 3.59472 9.32568 3.59473 11.2446V17.5686C3.59473 19.2024 4.59134 20.6025 6.00749 21.1895C5.93461 20.2043 5.93466 18.8218 5.93473 17.6717V12.3477V12.2446C5.93465 10.8561 5.93458 9.6598 6.06286 8.70178C6.20035 7.67507 6.5104 6.69091 7.30547 5.89264C8.10054 5.09437 9.08077 4.78308 10.1034 4.64504C11.0576 4.51624 12.2492 4.51631 13.632 4.51639L13.7347 4.5164H16.8547L16.9574 4.51639C18.3403 4.51631 19.5293 4.51624 20.4835 4.64504C19.9127 3.19376 18.5031 2.16699 16.8547 2.16699Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.49512 12.3472C7.49512 9.39377 7.49512 7.91709 8.40894 6.99959C9.32277 6.08209 10.7936 6.08209 13.7351 6.08209H16.8551C19.7967 6.08209 21.2674 6.08209 22.1813 6.99959C23.0951 7.91709 23.0951 9.39378 23.0951 12.3472V17.5681C23.0951 20.5215 23.0951 21.9981 22.1813 22.9156C21.2674 23.8331 19.7967 23.8331 16.8551 23.8331H13.7351C10.7936 23.8331 9.32277 23.8331 8.40894 22.9156C7.49512 21.9981 7.49512 20.5215 7.49512 17.5681V12.3472Z",
    fill: "url(#paint1_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 12.0391,
    y1: 21.1895,
    x2: 12.0391,
    y2: 2.16699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 15.2951,
    y1: 23.8331,
    x2: 15.2951,
    y2: 6.08209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#822AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RevampedLobbyCopy);
export default __webpack_public_path__ + "static/media/v2_revamped_lobby_copy.377176ffb2ffed99939b8bc63c1b963c.svg";
export { ForwardRef as ReactComponent };